import { HiPlus } from "react-icons/hi";
import DoctorLookup from "../DoctorLookup";
import { Field, FieldGrid } from "./FormField";
import { TERMINAL_ADMISSION_STATUSES } from "../../utils";

const AdditionalDoctorsSection = ({ admission, autocompleteSettings, onAdmissionChange, ProcessingStatusIcon }) => {
  const isLocked = TERMINAL_ADMISSION_STATUSES.includes(admission?.status);
  const additionalDoctors = (admission?.additionalDoctors || []).filter(
    (doctor) => !isLocked || doctor?.code || doctor?.RPPS || doctor?.ADELI || doctor?.lastName || doctor?.firstName,
  );

  if (isLocked && additionalDoctors.length === 0) return null;

  return (
    <div className="mb-4">
      <h3 className="section-title mb-2">
        <span>Médecins supplémentaires</span>
      </h3>
      <div className="card px-4 py-3">
        {additionalDoctors.length > 0 && (
          <FieldGrid>
            {additionalDoctors.map((doctor, index) => (
              <Field key={`additional-doctor-${index}`} label={`Médecin ${index + 1}`} span={12}>
                <DoctorLookup
                  placeholder="Rechercher un médecin..."
                  initialDoctor={doctor}
                  onDoctorSelect={(nextDoctor) => {
                    const updatedDoctors = additionalDoctors.map((existingDoctor, doctorIndex) =>
                      doctorIndex === index ? nextDoctor : existingDoctor,
                    );
                    onAdmissionChange([{ field: "additionalDoctors", value: updatedDoctors }]);
                  }}
                  onDoctorRemove={() => {
                    const updatedDoctors = additionalDoctors.filter((_, doctorIndex) => doctorIndex !== index);
                    onAdmissionChange([{ field: "additionalDoctors", value: updatedDoctors }]);
                  }}
                  autocompleteEnabled={autocompleteSettings.doctor}
                  removable
                  disabled={isLocked}
                  icon={<ProcessingStatusIcon type="ADDITIONAL_DOCTOR" referenceId={doctor._id} />}
                />
              </Field>
            ))}
          </FieldGrid>
        )}
        {!isLocked && (
          <div className={additionalDoctors.length > 0 ? "mt-2" : ""}>
            {autocompleteSettings.doctor === true ? (
              <DoctorLookup
                onDoctorSelect={(nextDoctor) =>
                  onAdmissionChange([{ field: "additionalDoctors", value: [...additionalDoctors, nextDoctor] }])
                }
                searchBarOnly={true}
                placeholder="Ajouter un médecin..."
                autocompleteEnabled={autocompleteSettings.doctor}
              />
            ) : (
              <button
                type="button"
                className="flex w-full items-center justify-center gap-2 rounded-md border border-dashed border-gray-300 bg-transparent px-3 py-2 text-xs text-gray-500 transition-colors hover:border-primary-400 hover:bg-primary-50 hover:text-primary-600"
                onClick={() => onAdmissionChange([{ field: "additionalDoctors", value: [...additionalDoctors, {}] }])}
              >
                <HiPlus className="h-3.5 w-3.5" />
                Ajouter un médecin
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default AdditionalDoctorsSection;
